import { render, staticRenderFns } from "./FqaDictDataList.vue?vue&type=template&id=19cb1c99&scoped=true&"
import script from "./FqaDictDataList.vue?vue&type=script&lang=js&"
export * from "./FqaDictDataList.vue?vue&type=script&lang=js&"
import style0 from "./FqaDictDataList.vue?vue&type=style&index=0&id=19cb1c99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb1c99",
  null
  
)

export default component.exports